import React, { useContext, useState } from "react";
import axios from "axios";
import { PitchContext } from "../context/PitchContex";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const { backendURL, setPending, setAlertMessage, setShowAlert, setIsErr } =
    useContext(PitchContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setPending(true);

    axios
      .post(backendURL + "user/send-update-password-link", {
        email,
      })
      .then((response) => {
        setPending(false);
        if (response.data.success) {
          setIsErr(false);
          setAlertMessage(response.data.message);
          setShowAlert(true);
        } else {
          setIsErr(true);
          setAlertMessage(response.data.message);
          setShowAlert(true);
        }
      })
      .catch((err) => {
        setPending(false);
        setIsErr(true);
        setAlertMessage(err.response.data.message);
        setShowAlert(true);
      });
  };

  return (
    <div className="sm:min-h-screen flex items-center justify-center bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white p-6 rounded-xl shadow-lg">
        <div>
          <h2 className="mt-6 text-center text-3xl font-bold text-gray-900">
            Şifre Yenileme
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Şifre sıfırlama bağlantısını almak için e-postanızı girin
          </p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="email" className="sr-only">
                Email address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="appearance-none rounded-lg relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-[#6ca87e] focus:border-[#6ca87e] focus:z-10 sm:text-sm"
                placeholder="E-posta"
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              className={`group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-[#6ca87e] hover:bg-[#5a906a] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 cursor-pointer`}
            >
              Sıfırlama Bağlantısını Gönder
            </button>
          </div>
        </form>

        <div className="text-center">
          <a
            href="/profil"
            className="font-medium text-[#6ca87e] hover:text-[#5a906a]"
          >
            Giriş Sayfasına Geri Dön
          </a>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
